import gibTypesActions from './actions';
import { GibTypesState } from './types';
import { createSlice } from '@reduxjs/toolkit';

const initialState: GibTypesState = {
  gibTypes: [],
  gibTypesError: null,
  gibTypesLoading: false,
  gibTypesIsEmpty: false,
};

export const gibTypesSlice = createSlice({
  initialState,
  name: 'gibTypes',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(gibTypesActions.getGibTypes.pending, (state) => {
      state.gibTypesLoading = true;
    });

    builder.addCase(gibTypesActions.getGibTypes.fulfilled, (state, { payload: { gibTypes } }) => {
      state.gibTypes = gibTypes;
      state.gibTypesError = null;
      state.gibTypesLoading = false;
      state.gibTypesIsEmpty = !!!gibTypes.length;
    });

    builder.addCase(gibTypesActions.getGibTypes.rejected, (state, { error }) => {
      state.gibTypesLoading = false;
      state.gibTypesError = error;
    });
  },
});

export default gibTypesSlice.reducer;
